<template>
  <div class="flex flex-wrap justify-center">
    <ro-h-anchor-button
      class="p-2 flex justify-center w-1/2 md:w-auto md:p-0 my-2 lg:my-0"
      :icon="'/assets/icon-solution.png'"
      :href="'#solution'"
      >Solution</ro-h-anchor-button
    >
    <ro-h-anchor-button
      class="p-2 flex justify-center w-1/2 md:w-auto md:p-0 my-2 lg:my-0"
      :icon="'/assets/icon-rotachrom.png'"
      :href="'#rotaChrom'"
      >RotaChrom</ro-h-anchor-button
    >
    <ro-h-anchor-button
      class="p-2 flex justify-center w-1/2 md:w-auto md:p-0 my-2 lg:my-0 "
      :icon="'/assets/icon-heidolph.png'"
      :href="'#heidolph'"
      >Heidolph</ro-h-anchor-button
    >
    <!-- <ro-h-anchor-button
      class="p-2 flex justify-center w-1/2 md:w-auto md:p-0 my-2 lg:my-0"
      :icon="'/assets/icon-exhibitions.png'"
      :href="'#exhibitions'"
      >Exhibitions</ro-h-anchor-button
    > -->
    <ro-h-anchor-button
      class="p-2 flex justify-center w-1/2 md:w-auto md:p-0 my-2 lg:my-0 "
      :icon="'/assets/icon-contact.png'"
      :href="'#contact'"
      >Contact</ro-h-anchor-button
    >
  </div>
</template>

<script>
import RoHAnchorButton from "@/components/RoHAnchorButton.vue";
export default {
  name: "RoHAnchorList",
  components: {
    RoHAnchorButton,
  },
};
</script>

<style scoped></style>
